export const events = {
	eventType: {
		eventType_BATTERY_LOW: "Low Battery",
		eventType_MAINS_POWER_FAIL: "Mains Power Failure",
		eventType_SENSOR_INPUT_FLEXIPAD: "Leak Sensor Alarm",
		eventType_SENSOR_INPUT_FLOWSTOP: "FlowStop Leak Alarm",
		eventType_SENSOR_INPUT_RANGER: "Ranger Sensor Alarm",
		eventType_RELAY: "FlowStop Valve",
		eventType_ALARM_ACTIVE: "Alarm Active",
		eventType_OUT_OF_COMMS: "Device Connection Lost",
	},
	management: {
		pageTitle: "Events",
		liveEvents: "Live Events",
		archiveEvents: "Archived Events",
		table: {
			type: "Event Type",
			deviceName: "Device",
			duration: "Duration",
			location: "Location",
		},
	},
};
